import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class VisualizationsRoute extends Route {
  @service keywords;
  @service uiPages;

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: 'Access data visualizations from the Bureau of Reclamation that '
            + 'enhance understanding of resources managed by the Bureau of Reclamation, '
            + 'including water, reservoir operations, water quality, hydropower, '
            + 'endangered and invasive species, and more.',
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(
            true,
            this.keywords.strings['visualizations-keywords'],
          ),
        },
      },
    ];
  }

  @breadcrumb crumb = 'Visualizations';

  model() {
    return hash({
      visualizations: this.uiPages.get('visualizations'),
    });
  }
}
